module.exports = __webpack_public_path__ + "static/media/volunteer.6cbae322.svg";